import React from 'react';
import { motion } from 'framer-motion';
export function DifferenceSection() {
  const outcomes = ['Menos hinchazón — especialmente al final del día', 'Más claridad mental y energía estable', 'Menos ansiedad nocturna y mejor descanso', 'Ropa más cómoda sin obsesión con el peso', 'Menos antojos — sobre todo de tarde', 'Más confianza en cómo te sentís cada día'];
  return <section className="bg-gradient-hero py-24 md:py-32 px-5 md:px-8" data-id="element-34">
      <div className="max-w-xl mx-auto" data-id="element-35">
        <motion.h2 initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="font-display font-semibold text-[#F0E8D8] text-center leading-[1.12]" data-id="element-36">
          <span className="block text-[32px] md:text-5xl" data-id="element-37">
            En 21 días podés empezar
          </span>
          <span className="block text-[32px] md:text-5xl mt-1" data-id="element-38">
            a{' '}
            <span className="italic text-gradient-gold" data-id="element-39">
              sentir la diferencia
            </span>
          </span>
        </motion.h2> <ul className="mt-12 space-y-3.5" data-id="element-40">
          {outcomes.map((item, i) => <motion.li key={i} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.08
        }} className="flex items-center gap-4 rounded-[3px] border-[0.5px] border-gold/15 bg-white/[0.02] px-5 py-4" data-id="element-41">
              <span className="w-2 h-2 rounded-full bg-[#C8A870] flex-shrink-0" data-id="element-42" />
              <span className="font-body text-foreground/80 text-[17px]" data-id="element-43">
                {item}
              </span>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}
{/* Eyebrow */}
<motion.p initial={{
  opacity: 0,
  y: 12
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true
}} transition={{
  duration: 0.6
}} className="uppercase tracking-[0.3em] text-[#C8A870] font-semibold mb-6 text-[12px]" data-id="element-44">
          TU PRÓXIMO PASO
        </motion.p>;
{/* Title */}
<motion.h2 initial={{
  opacity: 0,
  y: 16
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true
}} transition={{
  duration: 0.7
}} className="font-display text-4xl md:text-6xl font-semibold leading-[1.08] text-[#F0E8D8]" data-id="element-45">
          Tu cuerpo está cambiando. Merece un enfoque diferente
        </motion.h2>;